import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const sellerApi = createApi({
  reducerPath: reducerPaths.sellerApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getSellerProfile: builder.query({
      query: () => {
        return {
          url: `/seller/profile`,
          method: "GET"
        }
      }
    }),
    updateSellerProfile: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/seller/profile/update`,
          method: "POST",
          body: payload
        }
      }
    })
  }),
});

export const {
  useLazyGetSellerProfileQuery,
  useUpdateSellerProfileMutation
} = sellerApi;
